import { WithList, WithPagination } from '@bv/api/crud';
import { mixinClass } from '@bv/utils';

class TeamsApi extends mixinClass(WithList<TeamItem>, WithPagination<TeamItem>) {
  public constructor(public endpoint = 'iam/teams') {
    super(endpoint);
  }
}

export const teamsApi = new TeamsApi();
